import { render, staticRenderFns } from "./MonthQueueRaport.vue?vue&type=template&id=d6142e22"
import script from "./MonthQueueRaport.vue?vue&type=script&lang=js"
export * from "./MonthQueueRaport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports